/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowRampLeft2 = createReactComponent("outline", "arrow-ramp-left-2", "IconArrowRampLeft2", [["path", { "d": "M18 3v8.707", "key": "svg-0" }], ["path", { "d": "M8 14l-4 -4l4 -4", "key": "svg-1" }], ["path", { "d": "M18 21c0 -6.075 -4.925 -11 -11 -11h-3", "key": "svg-2" }]]);

export { IconArrowRampLeft2 as default };
//# sourceMappingURL=IconArrowRampLeft2.mjs.map
